// Tabular view. Click anywhere on a row opens the job edit modal.
// Columns mirror the mockup .list-table at production-schedule.html
// line 894.
import type { JobDto } from "../../../../../../shared/types/production-schedule";
import { fmtDate } from "../lib/dates";
import { jobBaysFor } from "../lib/stageHelpers";
import { PriorityBadge } from "../components/PriorityBadge";
import { StatusBadge } from "../components/StatusBadge";
import { BayChip } from "../components/BayChip";
import { AssigneeChip } from "../components/AssigneeChip";

interface Props {
  jobs: JobDto[];
  onOpenJob(id: number): void;
}

export function ListView({ jobs, onOpenJob }: Props) {
  return (
    <div style={{ overflowX: "auto" }}>
      <table className="list-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Job Name</th>
            <th>Customer</th>
            <th>Type</th>
            <th>Bay</th>
            <th>Spools</th>
            <th>Hrs</th>
            <th>Status</th>
            <th>Priority</th>
            <th>Assignee</th>
            <th>Start</th>
            <th>Due</th>
          </tr>
        </thead>
        <tbody>
          {jobs.map((j) => {
            const spools = j.spools.length;
            const hrs = j.spools.reduce((acc, s) => acc + s.hours, 0);
            return (
              <tr
                key={j.id}
                onClick={() => onOpenJob(j.id)}
                style={{ cursor: "pointer" }}
              >
                <td style={{ fontFamily: "var(--bsp-font-mono)", fontWeight: 700, color: "var(--bsp-blue)" }}>
                  {j.jobNumber}
                </td>
                <td style={{ fontWeight: 600, color: "var(--bsp-dark)" }}>{j.name}</td>
                <td>{j.customer ?? "—"}</td>
                <td>{j.solutionType?.name ?? "—"}</td>
                <td>
                  <BayChip bays={jobBaysFor({ spools: j.spools, jobBay: j.bay })} />
                </td>
                <td style={{ fontFamily: "var(--bsp-font-mono)" }}>{spools}</td>
                <td style={{ fontFamily: "var(--bsp-font-mono)" }}>{hrs.toFixed(1)}h</td>
                <td>
                  <StatusBadge status={j.status} />
                </td>
                <td>
                  <PriorityBadge priority={j.priority} />
                </td>
                <td>
                  <AssigneeChip member={j.assignee} size={22} showName />
                </td>
                <td style={{ fontFamily: "var(--bsp-font-mono)", fontSize: 11 }}>
                  {fmtDate(j.startDate)}
                </td>
                <td style={{ fontFamily: "var(--bsp-font-mono)", fontSize: 11 }}>
                  {fmtDate(j.dueDate)}
                </td>
              </tr>
            );
          })}
          {jobs.length === 0 && (
            <tr>
              <td colSpan={12} style={{ textAlign: "center", color: "var(--bsp-fg-muted)", padding: 24 }}>
                No jobs match the current filters.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
